import React from 'react';
export function TomosSection() {
  const tomos = [{
    emoji: '💪',
    title: 'TOMO 1: EL MOTOR',
    subtitle: 'La fuerza que no viene del gimnasio',
    points: ['Rutinas de 30 minutos para meter entre el laburo y la cena', 'Cómo activar la cadena posterior que tenés apagada', 'Potencia en cuádriceps sin que te quemen las piernas en la subida']
  }, {
    emoji: '🦴',
    title: 'TOMO 2: EL CHASIS',
    subtitle: 'Adiós al dolor de espalda del lunes',
    points: ['Eliminá el dolor lumbar después de salidas largas', 'Ajustes milimétricos de asiento y manubrio que valen más que cualquier componente', 'Protocolo de estiramiento post-rodada para estar 10 puntos al día siguiente']
  }, {
    emoji: '🍌',
    title: 'TOMO 3: EL COMBUSTIBLE',
    subtitle: 'La pájara es opcional. Vos elegís si la tenés.',
    points: ['Qué comer antes de salir con lo que tenés en la alacena', 'Cómo evitar el muro de los 50 km para siempre', 'Geles y barras caseras a precio de supermercado']
  }, {
    emoji: '🧠',
    title: 'TOMO 4: EL PILOTO',
    subtitle: 'Pedalear inteligente vale más que pedalear fuerte',
    points: ['El arte de chupar rueda para ahorrar un 30% de energía', 'Cadencia exacta para no explotar glucógeno en las subidas', 'Psicología de ruta cuando el cuerpo dice que pares y todavía podés más']
  }, {
    emoji: '🔧',
    title: 'TOMO 5: EL TALLER',
    subtitle: 'Tu mecánico de bolsillo para cuando la bici falla a 40km de casa',
    points: ['El kit de emergencia que tenés que llevar sí o sí', 'Cómo cambiar una cadena cortada en 2 minutos', 'Presión de cubiertas para no pinchar ni perder rendimiento']
  }];
  return <section className="bg-gray-900 text-white py-16 px-4" data-id="element-199">
      <div className="max-w-6xl mx-auto" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-201">
          QUÉ TE LLEVÁS HOY
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          {tomos.map((tomo, index) => <div key={index} className="bg-gray-800 border border-gray-700 rounded-lg p-6 hover:border-green-500 transition-colors duration-300" data-id="element-203">
              <div className="text-4xl mb-4" data-id="element-204">{tomo.emoji}</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-205">{tomo.title}</h3>
              <p className="text-green-400 font-semibold mb-4" data-id="element-206">
                {tomo.subtitle}
              </p>
              <ul className="space-y-2 text-gray-300" data-id="element-207">
                {tomo.points.map((point, i) => <li key={i} className="flex items-start gap-2" data-id="element-208">
                    <span className="text-green-500 mt-1" data-id="element-209">•</span>
                    <span className="text-sm" data-id="element-210">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}